import { render, staticRenderFns } from "./CampoNumberBase.vue?vue&type=template&id=586b20c7&scoped=true"
import script from "./CampoNumberBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoNumberBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CampoNumberBase.vue?vue&type=style&index=0&id=586b20c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b20c7",
  null
  
)

export default component.exports